module.exports = __webpack_public_path__ + "img/logo.c85669d4.png";